import React from 'react';

import CN from 'clsx';

import { dataRole } from '@r-client/shared/util/core';

import styles from './close-button.module.scss';
export interface ICloseButtonProps {
  className?: string;
  role?: string;
  dataTestId?: string;
  onClick?(event: React.MouseEvent<Element, MouseEvent>): void;
}

export const CloseButton = function CloseButton({
  className,
  role,
  onClick,
  dataTestId,
}: ICloseButtonProps) {
  return (
    <button
      className={CN(styles.closeButton, className)}
      type="button"
      data-testid={dataTestId}
      {...dataRole(role)}
      onClick={onClick}
    >
      &times;
    </button>
  );
};
